<template>
  <div id="add-new-order-modal">
    <v-layout row justify-center>
      <v-dialog v-model="sendToIntShipmentModal" persistent max-width="450px">
        <v-card>
          <form action="" @submit.prevent="submitForm()">
            <v-card-title>
              <v-flex xs11 sm11 md11><span class="headline">Send to Int Shipment</span></v-flex>
              <v-flex xs1 sm1 md1>
                <v-btn flat @click="closeSendToIntShipmentModal" class="close">&times;</v-btn>
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm5 md4>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="QrCode*"
                      v-model="sendToIntShipmentData.order_id"
                      :error-messages="errors.collect('qrcode')"
                      v-validate="'required'"
                      data-vv-name="qrcode"
                      autofocus
                    />
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <div style="height:0px;overflow:hidden">
                <v-btn id="sendButton" type="submit" style="height:auto" outline color="success"
                  >Send</v-btn
                >
              </div>
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: [
    'sendToIntShipmentModal',
    'closeSendToIntShipmentModal',
    'sendToIntShipmentData',
    'sendToIntShipment'
  ],

  methods: {
    submitForm() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.sendToIntShipment()
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/sendToIntShipment.vue